(function () {
  'use strict';

  var drawer = document.getElementById('fk-cat-drawer');
  if (!drawer) return;

  var panel = drawer.querySelector('.fkd__panel');
  var firstFocusable = null;
  var lastTrigger = null;
  var touchStartX = 0;
  var touchStartY = 0;

  function getFocusable() {
    return Array.from(
      panel.querySelectorAll(
        'a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])'
      )
    );
  }

  function openDrawer() {
    drawer.hidden = false;
    document.body.style.overflow = 'hidden';
    requestAnimationFrame(function () {
      drawer.classList.add('fkd--open');
      // Focus only after the drawer is visible (closed state is visibility:hidden).
      var focusable = getFocusable();
      firstFocusable = focusable[0] || null;
      if (firstFocusable) {
        firstFocusable.focus();
        // Under prefers-reduced-motion the visibility step may not have committed yet,
        // so focus() is ignored; retry shortly after.
        if (document.activeElement !== firstFocusable) {
          setTimeout(function () {
            if (!drawer.hidden && drawer.classList.contains('fkd--open')) firstFocusable.focus();
          }, 50);
        }
      }
    });
  }

  function closeDrawer() {
    drawer.classList.remove('fkd--open');
    document.body.style.overflow = '';
    var finished = false;
    var finish = function () {
      if (finished) return;
      finished = true;
      panel.removeEventListener('transitionend', finish);
      clearTimeout(fallback);
      if (drawer.classList.contains('fkd--open')) return;
      drawer.hidden = true;
      if (lastTrigger) lastTrigger.focus();
    };
    panel.addEventListener('transitionend', finish);
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var fallback = reduceMotion ? null : setTimeout(finish, 300);
    if (reduceMotion) requestAnimationFrame(finish);
  }

  // Open triggers
  document.querySelectorAll('[data-fk-drawer-open]').forEach(function (el) {
    el.addEventListener('click', function (e) {
      e.preventDefault();
      lastTrigger = e.currentTarget;
      openDrawer();
    });
  });

  // Close triggers (overlay + close button + CTA)
  drawer.querySelectorAll('[data-fk-drawer-close]').forEach(function (el) {
    el.addEventListener('click', closeDrawer);
  });

  // Escape key
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' || drawer.hidden) return;
    closeDrawer();
  });

  // Focus trap
  drawer.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || drawer.hidden) return;
    var focusable = getFocusable();
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  });

  // Swipe left to close
  panel.addEventListener('touchstart', function (e) {
    touchStartX = e.touches[0].clientX;
    touchStartY = e.touches[0].clientY;
  }, { passive: true });

  panel.addEventListener('touchend', function (e) {
    var dx = e.changedTouches[0].clientX - touchStartX;
    var dy = Math.abs(e.changedTouches[0].clientY - touchStartY);
    if (dx < -56 && dy < 40) closeDrawer();
  }, { passive: true });
})();
